// extracted by mini-css-extract-plugin
export var closeButton = "_ks-1";
export var closeX = "_ks-3";
export var container = "_ks-0";
export var image = "_ks-2";